import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en terminos-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/terminos",
  head: () => ({
    meta: seoMeta({
      title: "Términos y Condiciones — Calistenia Progresiva",
      description: "Condiciones de uso del sitio, las clases y el Portal de Calistenia Progresiva.",
      path: "/terminos",
    }),
    links: [canonicalLink("/terminos")],
  }),
  component: lazyRouteComponent(() => import("./terminos-page"), "TerminosPage"),
});
